"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const MenuList_1 = __importDefault(require("@material-ui/core/MenuList"));
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const menu_item_1 = require("./menu-item");
const menu_styles_1 = require("./menu-styles");
function Menu({ items, classOverrides, }) {
    const classes = menu_styles_1.useStyles();
    const [openedItem, setOpenedItem] = react_1.useState(null);
    const handleClick = event_callback_hook_1.useEventCallback((index) => {
        if (openedItem !== index) {
            setOpenedItem(index);
        }
        else {
            setOpenedItem(null);
        }
    });
    const handleHover = event_callback_hook_1.useEventCallback((index) => {
        if (openedItem !== null) {
            setOpenedItem(index);
        }
    });
    const handleClickAway = event_callback_hook_1.useEventCallback((index) => {
        if (openedItem === index) {
            setOpenedItem(null);
        }
    });
    return (react_1.default.createElement(MenuList_1.default, { disablePadding: true, className: clsx_1.default(classes.menu, classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.menu) }, items.map((item, index) => (react_1.default.createElement(menu_item_1.MenuItem, { item: item, key: index, index: index, onClick: handleClick, onHover: handleHover, onClickAway: handleClickAway, opened: index === openedItem, classOverrides: classOverrides })))));
}
exports.Menu = Menu;
//# sourceMappingURL=menu.js.map